/*
 * AI 填表员 · 快捷入口名 → 英文 taskName 映射(自动生成勿手改)
 *
 * 用途:
 *   1. 点击快捷入口 → upload 带 fileName 匹配 OSS 预生成模板
 *   2. 首条会话隐藏注入 <aiclerk-task-name>,让 LLM 理解本次填表任务的类型
 * taskName 全局唯一、纯 ASCII snake_case。入口名与 industryChips / HomeV3 的 chip.label 对应。
 */

export const CHIP_TASK_NAME: Record<string, string> = {
  'ATM 巡检登记': 'atm_inspection_register',
  GSP日常检查: 'gsp_daily_inspection',
  POP物料上架: 'pop_material_display',
  一桩一档表: 'per_pile_archive_form',
  上户安全巡查: 'household_safety_inspection',
  上门服务: 'onsite_service',
  上门服务工单: 'onsite_service_work_order',
  下地记工表: 'field_labor_worklog',
  专线开通验收: 'leased_line_activation_acceptance',
  业主报修单: 'owner_repair_request',
  业务员每日拜访: 'salesperson_daily_visit',
  临期商品清点: 'near_expiry_goods_count',
  临期报损登记: 'near_expiry_loss_register',
  临期效期盘点: 'near_expiry_shelf_life_stocktake',
  主体结构验收: 'main_structure_acceptance',
  主材进场验收: 'main_material_onsite_acceptance',
  交房验收单: 'house_handover_acceptance',
  交通违法记录: 'traffic_violation_record',
  产业运行监测: 'industry_operation_monitoring',
  仓库卫生隐患: 'warehouse_hygiene_hazard',
  仓库巡检记录: 'warehouse_inspection_record',
  代驾司机考勤: 'designated_driver_attendance',
  仪器巡检记录: 'instrument_inspection_record',
  价签促销核查: 'price_tag_promotion_verification',
  企业走访调研: 'enterprise_visit_survey',
  会员登记表: 'member_registration_form',
  会议签到表: 'meeting_checkin_sheet',
  传单派发记录: 'flyer_distribution_record',
  作业日报: 'operation_daily_report',
  作业量统计: 'workload_statistics',
  供应商索证索票: 'supplier_credential_collection',
  促销员到岗签到: 'promoter_arrival_checkin',
  促销陈列布置: 'promotion_display_setup',
  保单送达签收: 'policy_delivery_signoff',
  保洁绿化台账: 'cleaning_greening_log',
  保洁考勤表: 'cleaning_staff_attendance',
  保洁验收单: 'cleaning_acceptance_form',
  保质期临期盘查: 'shelf_life_near_expiry_check',
  值班巡岗记录: 'duty_patrol_record',
  健康监测台账: 'health_monitoring_log',
  健康随访登记: 'health_followup_register',
  催收跟进: 'collection_followup',
  光猫扫码登记: 'optical_modem_scan_register',
  党建活动记录: 'party_building_activity_record',
  入户走访登记: 'door_to_door_visit_register',
  公区保洁巡检: 'common_area_cleaning_inspection',
  公厕保洁记录: 'public_toilet_cleaning_record',
  公益活动台账: 'public_welfare_activity_log',
  公示牌台账: 'notice_board_log',
  农机保养台账: 'farm_machinery_maintenance_log',
  冷柜温控巡检: 'freezer_temperature_inspection',
  冷链温度记录: 'cold_chain_temperature_record',
  出工日报: 'manpower_daily_report',
  出车登记表: 'vehicle_dispatch_register',
  到货扫码验收: 'arrival_scan_acceptance',
  到货收货登记: 'arrival_receiving_register',
  办公隐患整改: 'office_hazard_rectification',
  劳动监察检查: 'labor_supervision_inspection',
  医废扫码交接: 'medical_waste_scan_handover',
  医废转运台账: 'medical_waste_transfer_log',
  医疗器械安装: 'medical_device_installation',
  医疗废物登记: 'medical_waste_register',
  医院基建验收: 'hospital_construction_acceptance',
  单车维修台账: 'bike_maintenance_log',
  卫星地面站巡检: 'satellite_ground_station_inspection',
  卫生检查表: 'hygiene_inspection_sheet',
  卫生检查记录: 'hygiene_inspection_record',
  厅堂环境检查: 'lobby_environment_inspection',
  反洗钱核查: 'aml_verification',
  合规检查: 'compliance_inspection',
  员工排班考勤: 'staff_scheduling_attendance',
  商业服务工单: 'commercial_service_work_order',
  商品出库验货: 'goods_outbound_inspection',
  商品抽检登记: 'goods_sampling_register',
  园所隐患整改: 'kindergarten_hazard_rectification',
  困难帮扶登记: 'hardship_assistance_register',
  困难户走访表: 'hardship_household_visit_form',
  困难群体走访: 'vulnerable_group_visit',
  固定资产盘点: 'fixed_asset_stocktake',
  国补台账: 'national_subsidy_log',
  土地巡查记录: 'land_inspection_record',
  土地执法记录: 'land_enforcement_record',
  土地权属核查: 'land_ownership_verification',
  地块踏勘表: 'parcel_survey_form',
  地推人员打卡: 'ground_promotion_checkin',
  地推物料铺设: 'ground_promotion_material_layout',
  场地巡查记录: 'site_inspection_record',
  场馆安全巡检: 'venue_safety_inspection',
  垃圾分类督导: 'waste_sorting_supervision',
  垃圾清运台账: 'garbage_removal_log',
  培训课时记录: 'training_class_hour_record',
  基站巡检: 'base_station_inspection',
  堤坝巡查记录: 'dam_inspection_record',
  外事接待记录: 'foreign_affairs_reception_record',
  外勤打卡台账: 'field_checkin_log',
  外勤考勤: 'field_attendance',
  大棚建设进度: 'greenhouse_construction_progress',
  学员签到花名册: 'trainee_checkin_roster',
  学员签到表: 'trainee_checkin_sheet',
  学生宿舍查寝: 'student_dormitory_check',
  学生晨检记录: 'student_morning_check_record',
  安保维修考勤: 'security_maintenance_attendance',
  安全巡查记录表: 'safety_patrol_record',
  安全巡检台账: 'safety_inspection_log',
  安全检查台账: 'safety_check_log',
  安全生产月报: 'safety_production_monthly_report',
  安全隐患排查: 'safety_hazard_screening',
  实验器材登记: 'lab_equipment_register',
  实验室安全检查: 'laboratory_safety_inspection',
  实验室隐患: 'laboratory_hazard',
  客户回访记录: 'customer_followup_visit_record',
  客户尽调走访: 'customer_due_diligence_visit',
  客户签约登记: 'customer_signing_register',
  客户经理外拓: 'account_manager_outreach',
  客房查房质检: 'guestroom_inspection_quality_check',
  宣传活动汇总: 'publicity_activity_summary',
  家政服务台账: 'housekeeping_service_log',
  宽带装机: 'broadband_installation',
  尽调现场: 'due_diligence_onsite',
  巡检记录表: 'general_patrol_record',
  巡逻勤务台账: 'patrol_duty_log',
  工程形象进度: 'project_visual_progress',
  工程照片档案: 'engineering_photo_archive',
  市场巡查台账: 'market_inspection_log',
  市容整治记录: 'city_appearance_rectification_record',
  市容问题上报: 'city_appearance_issue_report',
  布线检查: 'cabling_inspection',
  布草洗涤盘点: 'linen_laundry_stocktake',
  带看登记表: 'property_viewing_register',
  幼儿接送交接: 'child_pickup_handover',
  幼儿晨检记录: 'toddler_morning_check_record',
  库房尾箱交接: 'warehouse_cash_box_handover',
  店员每日巡店: 'clerk_daily_store_patrol',
  开通验收: 'activation_acceptance',
  征地补偿登记: 'land_acquisition_compensation_register',
  志愿服务记录: 'volunteer_service_record',
  成品保护检查: 'finished_product_protection_inspection',
  成品质量抽检: 'finished_product_quality_sampling',
  户外广告巡检: 'outdoor_advertising_inspection',
  房源图册: 'listing_photo_album',
  房源盘点台账: 'listing_stocktake_log',
  执法检查记录: 'enforcement_inspection_record',
  承保标的核验: 'insured_subject_verification',
  技师排班考勤: 'technician_scheduling_attendance',
  技术服务单: 'technical_service_ticket',
  抄表登记: 'meter_reading_register',
  抄表记录: 'meter_reading_record',
  投放调度记录: 'deployment_dispatch_record',
  抢修工单: 'emergency_repair_work_order',
  护理员考勤: 'caregiver_attendance',
  护理巡房记录: 'nursing_ward_round_record',
  抵押物勘查: 'collateral_survey',
  抵押物核验: 'collateral_verification',
  拆迁入户登记: 'demolition_household_register',
  按日期归档: 'archive_by_date',
  捐赠物资登记: 'donated_supplies_register',
  接待走访登记: 'reception_visit_register',
  支护验收记录: 'support_structure_acceptance_record',
  故障工单: 'fault_work_order',
  故障缺陷: 'fault_defect_record',
  教具耗材登记: 'teaching_aid_consumable_register',
  教学楼巡查记录: 'teaching_building_inspection_record',
  教学物资登记: 'teaching_supplies_register',
  教学质检记录: 'teaching_quality_check_record',
  教学质量巡课: 'teaching_quality_class_patrol',
  教研备课记录: 'lesson_preparation_record',
  教职工考勤表: 'faculty_staff_attendance',
  整改前后对比: 'rectification_before_after',
  整改通知单: 'rectification_notice',
  文明城市迎检: 'civilized_city_inspection_prep',
  施工日报: 'construction_daily_report',
  施工进度日志: 'construction_progress_log',
  施工进度日报: 'construction_progress_daily_report',
  施工验收台账: 'construction_acceptance_log',
  日常巡查台账: 'routine_patrol_log',
  日常巡检记录: 'routine_inspection_record',
  明厨亮灶检查: 'open_kitchen_inspection',
  月嫂护理日志: 'maternity_nurse_care_log',
  月度业务汇报: 'monthly_business_report',
  月度工作汇报: 'monthly_work_report',
  月度执法汇报: 'monthly_enforcement_report',
  服务人员考勤: 'service_staff_attendance',
  服务器资产: 'server_asset_ledger',
  服药管理台账: 'medication_management_log',
  机房巡检: 'server_room_inspection',
  材料进场验收: 'material_onsite_acceptance',
  林区巡护记录: 'forest_patrol_record',
  校区隐患整改: 'campus_zone_hazard_rectification',
  校园卫生检查: 'campus_hygiene_inspection',
  校园巡查记录: 'campus_inspection_record',
  校园隐患整改: 'campus_hazard_rectification',
  校舍改造进度表: 'school_building_renovation_progress',
  校车安全巡检: 'school_bus_safety_inspection',
  样品采集登记: 'sample_collection_register',
  案发现场勘查: 'crime_scene_survey',
  档案影像: 'archive_imaging',
  桥梁桩基台账: 'bridge_pile_foundation_log',
  检测报告底稿: 'test_report_working_paper',
  每日工作汇报: 'daily_work_report',
  每日施工日志: 'daily_construction_log',
  民生实事登记: 'livelihood_project_register',
  民生走访记录: 'livelihood_visit_record',
  水位监测记录: 'water_level_monitoring_record',
  水电抄表记录: 'utility_meter_reading_record',
  水质取样台账: 'water_quality_sampling_log',
  水质检测: 'water_quality_testing',
  水质检测台账: 'water_quality_testing_log',
  水闸启闭记录: 'sluice_gate_operation_record',
  污染源排查: 'pollution_source_screening',
  沟槽临边巡检: 'trench_edge_inspection',
  河道隐患排查: 'river_channel_hazard_screening',
  活动执行记录: 'event_execution_record',
  活动日程表: 'event_schedule_table',
  消杀除虫报告: 'pest_control_report',
  消毒记录表: 'disinfection_record_sheet',
  消防安全巡查: 'fire_safety_inspection',
  消防检查表: 'fire_inspection_sheet',
  消防检查记录表: 'fire_inspection_record',
  消防演练记录: 'fire_drill_record',
  爆破作业记录: 'blasting_operation_record',
  物业维修台账: 'property_maintenance_log',
  物业隐患巡查: 'property_hazard_inspection',
  物种监测登记: 'species_monitoring_register',
  物资捐赠台账: 'supplies_donation_log',
  物资盘点表: 'supplies_stocktake_sheet',
  玩教具消毒记录: 'toy_teaching_aid_disinfection_record',
  环保督察整改: 'environmental_inspection_rectification',
  环卫车辆出勤: 'sanitation_vehicle_attendance',
  环境整治上报: 'environment_improvement_report',
  现场处置文书: 'onsite_disposal_document',
  现场调研记录: 'onsite_research_record',
  班前安全确认: 'pre_shift_safety_confirmation',
  理赔现场勘查: 'claim_scene_survey',
  瓦斯监测记录: 'gas_monitoring_record',
  生态修复记录: 'ecological_restoration_record',
  生鲜到货验收: 'fresh_produce_arrival_acceptance',
  田间巡查记录: 'farmland_inspection_record',
  电力巡线隐患: 'power_line_patrol_hazard',
  电池换电记录: 'battery_swap_record',
  界桩核查登记: 'boundary_marker_verification_register',
  病区巡查台账: 'ward_inspection_log',
  病媒消杀报告: 'vector_pest_control_report',
  直播课排期表: 'live_class_schedule_table',
  直播间巡检表: 'live_studio_inspection_sheet',
  矛盾调解台账: 'dispute_mediation_log',
  矿石出井台账: 'ore_hoisting_log',
  科室安全隐患: 'department_safety_hazard',
  科室消毒登记: 'department_disinfection_register',
  租赁合同台账: 'lease_contract_log',
  租赁点位巡查: 'rental_site_inspection',
  租赁物出入库: 'rental_item_inbound_outbound',
  租赁物盘点: 'rental_item_stocktake',
  站点消防巡查: 'station_fire_inspection',
  竞品价格巡查: 'competitor_price_inspection',
  竣工验收单: 'completion_acceptance_form',
  管网巡查: 'pipe_network_inspection',
  管网抢修记录: 'pipe_network_emergency_repair_record',
  管道敷设记录: 'pipeline_laying_record',
  线性工程进度: 'linear_project_progress',
  线路抢修: 'line_emergency_repair',
  线路故障: 'line_fault_record',
  终端SKU铺货: 'terminal_sku_distribution',
  经销商拜访记录: 'dealer_visit_record',
  统计入企核查: 'statistics_enterprise_verification',
  维修工单台账: 'repair_work_order_log',
  维修质量抽检: 'repair_quality_sampling',
  网格走访记录表: 'grid_visit_record_form',
  网点安全巡检: 'branch_safety_inspection',
  网点巡检: 'branch_inspection',
  网点营销布置: 'branch_marketing_setup',
  耕地保护台账: 'farmland_protection_log',
  耕地保护巡查: 'farmland_protection_inspection',
  膳食供餐记录: 'meal_catering_record',
  苗情长势记录: 'crop_growth_record',
  药品扫码巡检: 'drug_scan_inspection',
  药品批号盘点: 'drug_batch_stocktake',
  药品效期核查: 'drug_expiry_verification',
  药店客户拜访: 'pharmacy_customer_visit',
  街道巡查台账: 'street_inspection_log',
  街面市容巡查: 'street_appearance_inspection',
  装修安全巡查: 'renovation_safety_inspection',
  装修进度日报: 'renovation_progress_daily_report',
  装卸交接单: 'loading_unloading_handover',
  订单异常留证: 'order_exception_evidence',
  订单派车记录: 'order_vehicle_dispatch_record',
  设备器材台账: 'equipment_apparatus_log',
  设备完好检查: 'equipment_integrity_inspection',
  设备巡检: 'equipment_inspection',
  设备巡检记录: 'equipment_inspection_record',
  设备扫码建档: 'equipment_scan_archiving',
  设备点检表: 'equipment_spot_check_sheet',
  设备维保记录: 'equipment_maintenance_record',
  设备维修工单: 'equipment_repair_work_order',
  设备资产扫码: 'equipment_asset_scan',
  设施巡检记录: 'facility_inspection_record',
  设施维修工单: 'facility_repair_work_order',
  设施资产盘点: 'facility_asset_stocktake',
  设施隐患排查: 'facility_hazard_screening',
  设施验收登记: 'facility_acceptance_register',
  证件核验: 'credential_verification',
  试剂库存核对: 'reagent_inventory_check',
  课后服务打卡: 'after_school_service_checkin',
  课程排课表: 'course_scheduling_table',
  货损定损单: 'cargo_damage_assessment_form',
  货架SKU盘点: 'shelf_sku_stocktake',
  贷前尽调: 'pre_loan_due_diligence',
  贷后回访: 'post_loan_followup_visit',
  贷后风险巡查: 'post_loan_risk_inspection',
  赠品发放台账: 'gift_issuance_log',
  赠品发放记录: 'gift_issuance_record',
  走访凭证登记: 'visit_voucher_register',
  路基施工日报: 'roadbed_construction_daily_report',
  路演活动记录: 'roadshow_activity_record',
  路演走访: 'roadshow_visit',
  路面压实记录: 'pavement_compaction_record',
  车辆交接验车: 'vehicle_handover_inspection',
  车辆保养工单: 'vehicle_maintenance_work_order',
  车辆停放管理: 'vehicle_parking_management',
  车辆出车检查: 'vehicle_departure_check',
  车辆安全巡检: 'vehicle_safety_inspection',
  车辆安全隐患: 'vehicle_safety_hazard',
  车辆定损照片: 'vehicle_damage_assessment_photo',
  车辆编号台账: 'vehicle_number_log',
  车辆证照台账: 'vehicle_license_document_log',
  车间安全巡查: 'workshop_safety_inspection',
  车间隐患排查: 'workshop_hazard_screening',
  车险查勘定损: 'auto_insurance_damage_assessment',
  违停清运记录: 'illegal_parking_removal_record',
  违建巡查台账: 'illegal_construction_inspection_log',
  违法用地排查: 'illegal_land_use_screening',
  违法行为取证: 'illegal_act_evidence_collection',
  送货里程台账: 'delivery_mileage_log',
  适老隐患巡查: 'elderly_friendly_hazard_inspection',
  道路巡查台账: 'road_inspection_log',
  道路清扫检查: 'road_sweeping_inspection',
  配件出入库: 'spare_part_inbound_outbound',
  配送签收台账: 'delivery_signoff_log',
  配送订单交接: 'delivery_order_handover',
  配送车辆巡检: 'delivery_vehicle_inspection',
  配送里程台账: 'distribution_mileage_log',
  重点项目督查: 'key_project_supervision',
  长者照护记录: 'elderly_care_record',
  门店安全巡查: 'store_safety_inspection',
  门店装修施工: 'store_renovation_construction',
  门店装修验收: 'store_renovation_acceptance',
  门店陈列巡检: 'store_display_inspection',
  门店陈列检查: 'store_display_check',
  防汛物资盘点: 'flood_control_supplies_stocktake',
  防汛防台巡查: 'flood_typhoon_prevention_inspection',
  陈列生动化检查: 'display_vividization_check',
  隐患台账汇总表: 'hazard_ledger_summary',
  隐患巡查: 'hazard_inspection',
  隐患巡查记录: 'hazard_inspection_record',
  隐患排查: 'hazard_screening',
  隐患整改单: 'hazard_rectification_notice',
  隐患整改回复单: 'hazard_rectification_reply',
  隐蔽工程验收: 'concealed_work_acceptance',
  隧道施工巡检: 'tunnel_construction_inspection',
  面签留档: 'in_person_signing_archive',
  项目周报: 'project_weekly_report',
  项目验收: 'project_acceptance',
  风电巡检记录: 'wind_power_inspection_record',
  风险隐患排查: 'risk_hazard_screening',
  风险隐患识别: 'risk_hazard_identification',
  食堂餐饮检查: 'canteen_catering_inspection',
  食材进货验收: 'ingredient_procurement_acceptance',
  食药安全检查: 'food_drug_safety_inspection',
  餐具消毒留样: 'tableware_disinfection_sampling',
  餐点留样登记: 'meal_retained_sample_register',
  驻场考勤: 'onsite_stationed_attendance',
  骑手健康打卡: 'rider_health_checkin'
}

/** 入口名 → taskName;无对应(兜底入口)返回 undefined。 */
export function getChipTaskName(label: string): string | undefined {
  return CHIP_TASK_NAME[label]
}
